/**
 * Schema-typed Supabase client — the DB-contract gate's adoption surface.
 *
 * Same singleton as getSupabaseClient(), narrowed to the generated Database
 * type, so writes to nonexistent columns and reads of nonexistent tables are
 * COMPILE errors instead of runtime PGRST204s (the escape class behind
 * #337/#338 and the item_pool_memberships workspace_id insert).
 *
 * Adoption rule: NEW data-access code uses getTypedSupabaseClient(); existing
 * stores migrate opportunistically (typing the base client globally would
 * surface hundreds of latent errors at once — that burn-down is tracked in the
 * recovery program, not forced here).
 *
 * Types regenerate with `npm run db:types` (see scripts/regen-db-types.sh).
 */

import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '../types/database.generated';
import { getSupabaseClient } from './supabaseClient';

export type TypedSupabaseClient = SupabaseClient<Database>;

export function getTypedSupabaseClient(): TypedSupabaseClient {
  return getSupabaseClient() as TypedSupabaseClient;
}
